import Dropdown from '@stimulus-components/dropdown'
import Fuse from 'fuse.js'

export default class extends Dropdown {
    static targets = ["selected", "native", "customOption", "button", "search", "customOptionInput"]
    static values = {
        "null": String,
        "nullLabel": String,
        "customOptionLabel": String,
    }

    connect() {
        super.connect()
        this.init()
    }

    init() {
        this.nOptions = Array.from(this.nativeTarget.children)
        this.searcher = !this.hasSearchTarget ? undefined : new Fuse(
            this.nOptions.map(no => ({ label: no.textContent, value: no.value })),
            { keys: ["label"] }
        )
    }

    toggle(event) {
        super.toggle()
        this.selectOptionValue(event.params.option, event.params.optionLabel)
    }

    selectOptionValue(optionValue, optionLabel, prefix = '') {
        if (optionValue === undefined) return

        let nOption = this.nOptions.find(c => c.value === optionValue)
        const pOption = this.nOptions.find(no => no.hasAttribute("selected"))
        let cnOption = undefined;
        let pnOption = undefined;


        if (pOption !== undefined) {
            pOption.removeAttribute("selected")
            pnOption = this.customOptionTargets.find(pn => pn.getAttribute("data-selector-option-param") == pOption.value)
        }

        if (nOption !== undefined) {
            nOption.setAttribute('selected', '')
        } else if (this.hasCustomOptionInputTarget) {
            const customOption = document.createElement('option')
            customOption.textContent = optionLabel
            customOption.value = optionValue
            customOption.setAttribute('selected', '')
            this.nativeTarget.appendChild(customOption)
            this.init()
        }

        this.selectedTarget.textContent = prefix.length > 0 ? prefix + ': ' + optionLabel : optionLabel

        cnOption = this.customOptionTargets.find(cn => cn.getAttribute("data-selector-option-param") == optionValue)

        if (pnOption !== undefined) {
            const pnOptionLabel = pnOption.querySelector('[data-selector-target="customOptionLabel"]')
            const pnOptionIcon = pnOption.querySelector('[data-selector-target="customOptionIcon"]')
            pnOptionLabel.classList.remove("font-semibold")
            pnOptionIcon.classList.remove("flex")
            pnOptionLabel.classList.add("font-normal")
            pnOptionIcon.classList.add("hidden")
        }

        if (cnOption !== undefined) {
            const cnOptionLabel = cnOption.querySelector('[data-selector-target="customOptionLabel"]')
            const cnOptionIcon = cnOption.querySelector('[data-selector-target="customOptionIcon"]')
            cnOptionLabel.classList.add("font-semibold")
            cnOptionIcon.classList.add("flex")
            cnOptionLabel.classList.remove("font-normal")
            cnOptionIcon.classList.remove("hidden")
        }

        if (optionValue !== this.nullValue) {
            this.buttonTarget.classList.remove("font-normal")
            this.buttonTarget.classList.remove("border-gray-400")
            this.buttonTarget.classList.add("font-semibold")
            this.buttonTarget.classList.add('text-primary-950')
            this.buttonTarget.classList.add('border-primary-950')
            this.buttonTarget.classList.add('bg-bgprimary')
        } else {
            this.buttonTarget.classList.add("font-normal")
            this.buttonTarget.classList.add("border-gray-400")
            this.buttonTarget.classList.remove("font-semibold")
            this.buttonTarget.classList.remove('text-primary-950')
            this.buttonTarget.classList.remove('border-primary-950')
            this.buttonTarget.classList.remove('bg-bgprimary')
        }
    }

    onSearchClear() {
        if (!this.hasSearchTarget) return
        this.searchTarget.value = ''
        this.performSearch(this.searchTarget.value)
    }

    onSearchInput(event) {
        this.performSearch(event.target.value)
    }

    performSearch(searchTerm) {
        if (!this.hasSearchTarget) return

        if (searchTerm.length === 0) {
            this.customOptionTargets.forEach(element => {
                element.classList.remove("hidden")
            })
            return
        }

        const rValues = this.searcher.search(searchTerm).map(r => r.item.value)
        this.customOptionTargets.forEach(element => {
            const ev = element.getAttribute("data-selector-option-param")
            if (rValues.includes(ev)) {
                element.classList.remove("hidden")
                return
            }
            element.classList.add("hidden")
        })

    }

    hide(event) {
        super.hide(event)
    }

    onCustomOptionApply() {
        if (!this.hasCustomOptionInputTarget) return

        if (this.customOptionInputTarget.value.length === 0) {
            this.onCustomOptionInputClear()
            super.toggle()
            return
        }

        this.selectOptionValue(
            this.customOptionInputTarget.value,
            this.customOptionInputTarget.value,
            this.customOptionLabelValue
        )
        super.toggle()
    }

    onCustomOptionInputClear() {
        if (!this.hasCustomOptionInputTarget) return

        this.customOptionInputTarget.value = ''
        this.selectOptionValue(this.nullValue, this.nullLabelValue)
    }
}